// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  OrientationVersion,
  ScriptActionKind,
  CommandType,
  CommandTarget,
  CommandLocation,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  stepId: __t.string().name("step_id"),
  get orientationVersion() {
    return OrientationVersion.name("orientation_version");
  },
  beat: __t.u32(),
  sequenceOrder: __t.u32().name("sequence_order"),
  get actionKind() {
    return ScriptActionKind.name("action_kind");
  },
  get commandType() {
    return __t.option(CommandType).name("command_type");
  },
  twinIds: __t.array(__t.string()).name("twin_ids"),
  propertyNames: __t.array(__t.string()).name("property_names"),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  altitude: __t.option(__t.f64()),
  durationMs: __t.option(__t.u32()).name("duration_ms"),
  get flyTarget() {
    return __t.option(CommandTarget).name("fly_target");
  },
  get lookAtTarget() {
    return __t.option(CommandTarget).name("look_at_target");
  },
  lookAtBlendStart: __t.option(__t.f32()).name("look_at_blend_start"),
  distance: __t.option(__t.f32()),
  pitch: __t.option(__t.f32()),
  rotateSpeed: __t.option(__t.f32()).name("rotate_speed"),
  opacity: __t.option(__t.f32()),
  message: __t.option(__t.string()),
  narrateText: __t.option(__t.string()).name("narrate_text"),
  audioRef: __t.option(__t.string()).name("audio_ref"),
  paramsJson: __t.option(__t.string()).name("params_json"),
  get path() {
    return __t.option(__t.array(CommandLocation));
  },
  telemetryNames: __t.option(__t.array(__t.string())).name("telemetry_names"),
});
